import { createSelector } from 'reselect';
import { getIsMESEnabled } from 'lib/selectors/getIsMESEnabled';
import { getEffectiveErpResourceId } from './getEffectiveErpResourceId';
import { getAssociatedErpResourceIds } from './getApiErpResources';

/**
 * Selector that determines if a machine is mapped to ERP resources.
 *
 * A machine is considered mapped to ERP when:
 * - MES is enabled (company + machine) — the machine's resourceId serves as its laborResourceId
 * - A direct erpResourceId is assigned to the machine
 * - Associated ERP resources from machine groups (erpResources array)
 *
 * This mapping is required for ERP-driven workflows like work orders and labor tracking.
 */
const getIsMachineMappedToErp = createSelector(
  [getIsMESEnabled, getEffectiveErpResourceId, getAssociatedErpResourceIds],
  (mesEnabled, erpResourceId, erpResources) => {
    if (mesEnabled) return true;

    return !!(erpResourceId || erpResources?.length);
  }
);

export { getIsMachineMappedToErp };
